import { isCoreXQuery, configQuery, isSweepstakesQuery } from '@gig/magic-common';
import { BALANCE_QUERY, BALANCE_FIAT_CURRENCY_QUERY, BALANCE_CURRENCY_QUERY, BALANCE_CURRENCY_CHANGE, USER_LOGGED_IN_UPDATED, LANGUAGE_UPDATED, US_DOLLARS_BALANCE_UPDATED, ACCOUNT_PEP_BLOCK_QUERY, BALANCE_UPDATED, BALANCE_CHANGED, BALANCE_CURRENCY_UPDATED, IP_COUNTRY_QUERY, LANGUAGE_QUERY } from '@gig/magic-messages';
import { __awaiter, __generator } from 'tslib';
import { magic } from '@gig/magic-sdk';
import { Currency } from '@gig/magic-sdk/dist/adapter/users/signup';
import { countryToCurrency, languageToCurrency } from '@gig/magic-common/dist/util/helpers/currency';
import { getUserBalance, getFiatCurrency } from '@gig/magic-sdk/dist/util/balance';

var BalanceService = /** @class */ (function () {
    function BalanceService() {
        var _this = this;
        this.sweepstakesKey = 'sweepstakes-saved-currency';
        this.sweepstakesCurrency = Currency.GLD;
        this.balance = null;
        this.currency = null;
        this.isSweepstakes = false;
        this.accountsCoreX = [];
        isSweepstakesQuery().then(function (isSweepstakes) {
            _this.isSweepstakes = isSweepstakes;
            if (_this.isSweepstakes) {
                _this.sweepstakesCurrency = _this.readSavedSweepstakesCurrency();
            }
            _this.registerBalanceQuery();
            _this.registerCurrencyQuery();
            _this.registerFiatQuery();
            _this.subscribeToBalanceChanges();
            _this.subscribeToLanguageChanges();
            _this.registerCurrencyChange();
        });
    }
    BalanceService.prototype.registerBalanceQuery = function () {
        var _this = this;
        this.balanceQuerySubscription = window.queryBus.subscribe(BALANCE_QUERY, function (event) {
            var currency = event.payload;
            if (!currency) {
                return _this.balance;
            }
            return getUserBalance(_this.accountsCoreX, currency);
        });
    };
    BalanceService.prototype.registerFiatQuery = function () {
        var _this = this;
        this.fiatQuerySubscription = window.queryBus.subscribe(BALANCE_FIAT_CURRENCY_QUERY, function () {
            if (_this.isSweepstakes) {
                return (_this.getUserProfileCurrency() ||
                    getFiatCurrency(_this.accountsCoreX));
            }
            else {
                return _this.getCurrency();
            }
        });
    };
    BalanceService.prototype.registerCurrencyQuery = function () {
        var _this = this;
        window.queryBus.subscribe(BALANCE_CURRENCY_QUERY, function () {
            return _this.getCurrency();
        });
    };
    BalanceService.prototype.registerCurrencyChange = function () {
        var _this = this;
        window.commandBus.subscribe(BALANCE_CURRENCY_CHANGE, function (event) {
            var currency = event.payload;
            if (!_this.isSweepstakes || !currency) {
                return;
            }
            _this.sweepstakesCurrency = currency;
            localStorage.setItem(_this.sweepstakesKey, JSON.stringify({
                currency: currency,
            }));
            return _this.publishCurrencyChange();
        });
    };
    BalanceService.prototype.readSavedSweepstakesCurrency = function () {
        var data = localStorage.getItem(this.sweepstakesKey);
        if (!data) {
            return Currency.GLD;
        }
        try {
            return JSON.parse(data).currency;
        }
        catch (_a) {
            return Currency.GLD;
        }
    };
    BalanceService.prototype.unsubscribeBalanceQuery = function () {
        var _a;
        (_a = this.balanceQuerySubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        this.balanceQuerySubscription = undefined;
    };
    BalanceService.prototype.unsubscribeFiatQuery = function () {
        var _a;
        (_a = this.fiatQuerySubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        this.fiatQuerySubscription = undefined;
    };
    BalanceService.prototype.subscribeToBalanceChanges = function () {
        var _this = this;
        this.registerBalanceEvents();
        window.eventBus.subscribe(USER_LOGGED_IN_UPDATED, function (e) { return __awaiter(_this, void 0, void 0, function () {
            var isLoggedIn;
            return __generator(this, function (_a) {
                isLoggedIn = !!e.payload;
                if (isLoggedIn) {
                    this.handleSessionCreated();
                }
                else {
                    this.handleSessionDestroyed();
                }
                return [2 /*return*/];
            });
        }); }, { replay: true });
    };
    BalanceService.prototype.subscribeToLanguageChanges = function () {
        var _this = this;
        this.registerCurrencyEvents();
        window.eventBus.subscribe(LANGUAGE_UPDATED, function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.publishCurrencyChange()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
    };
    BalanceService.prototype.handleSessionCreated = function () {
        return __awaiter(this, void 0, void 0, function () {
            var user, isPepBlocked, _a, accounts, balance, usdExists;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.publishCurrencyChange()];
                    case 1:
                        _b.sent();
                        user = magic.session.getUser();
                        if (!user) {
                            console.warn('user is not saved in session');
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, window.queryBus.query(ACCOUNT_PEP_BLOCK_QUERY)];
                    case 2:
                        isPepBlocked = _b.sent();
                        if (isPepBlocked) {
                            return [2 /*return*/];
                        }
                        this.unsubscribeBalanceQuery();
                        this.unsubscribeFiatQuery();
                        return [4 /*yield*/, magic.invokeCached(60, magic.methods.wallet, 'getComputedBalance')(this.getUserCurrency())];
                    case 3:
                        _a = _b.sent(), accounts = _a.accounts, balance = _a.balance;
                        if (this.isSweepstakes) {
                            this.publishBalanceUpdated(balance);
                            usdExists = this.checkIfHasUsdBalance(accounts);
                            window.eventBus.publish(US_DOLLARS_BALANCE_UPDATED, usdExists);
                        }
                        this.publishBalanceUpdated(balance);
                        return [4 /*yield*/, this.subscribeToMagicUpdateEvent(accounts)];
                    case 4:
                        _b.sent();
                        this.registerBalanceQuery();
                        this.registerFiatQuery();
                        return [2 /*return*/];
                }
            });
        });
    };
    BalanceService.prototype.subscribeToMagicUpdateEvent = function (accounts) {
        return __awaiter(this, void 0, void 0, function () {
            var isCoreX;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.unsubscribeBalanceChanges();
                        return [4 /*yield*/, isCoreXQuery()];
                    case 1:
                        isCoreX = _a.sent();
                        if (isCoreX) {
                            this.accountsCoreX = accounts;
                            this.balanceSubscription = magic.events.computedBalanceChangedCoreX(accounts, function (updatedAccounts, eventAccount) {
                                _this.accountsCoreX = updatedAccounts;
                                var newBalance = getUserBalance(updatedAccounts, eventAccount.currencyCode);
                                _this.publishBalanceUpdated(newBalance);
                                _this.publishBalanceChanged(newBalance);
                            });
                        }
                        else {
                            this.balanceSubscription = magic.events.computedBalanceChanged(function (balance) {
                                _this.publishBalanceUpdated(balance);
                                _this.publishBalanceChanged(balance);
                            });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    BalanceService.prototype.handleSessionDestroyed = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.accountsCoreX = [];
                        return [4 /*yield*/, this.publishCurrencyChange()];
                    case 1:
                        _a.sent();
                        this.publishBalanceUpdated(null);
                        this.unsubscribeBalanceChanges();
                        return [2 /*return*/];
                }
            });
        });
    };
    BalanceService.prototype.publishBalanceUpdated = function (balance) {
        this.balance = balance;
        window.eventBus.publish(BALANCE_UPDATED, balance);
    };
    BalanceService.prototype.checkIfHasUsdBalance = function (accounts) {
        var _a;
        var usdAccount = accounts.find(function (account) { return account.currencyCode === Currency.USD; });
        return !!usdAccount && ((_a = usdAccount.balanceAmount) !== null && _a !== void 0 ? _a : 0) > 0;
    };
    BalanceService.prototype.publishBalanceChanged = function (balance) {
        window.eventBus.publish(BALANCE_CHANGED, balance);
    };
    BalanceService.prototype.publishCurrencyChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.getCurrency()];
                    case 1:
                        _a.currency = _b.sent();
                        window.eventBus.publish(BALANCE_CURRENCY_UPDATED, this.currency);
                        return [2 /*return*/];
                }
            });
        });
    };
    BalanceService.prototype.unsubscribeBalanceChanges = function () {
        if (this.balanceSubscription) {
            this.balanceSubscription.unsub();
            this.balanceSubscription = undefined;
        }
    };
    BalanceService.prototype.getCurrency = function () {
        return __awaiter(this, void 0, void 0, function () {
            var userCurrency, _a, country, language, countryCurrency, loggedOutCurrency;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        userCurrency = this.getUserCurrency();
                        if (userCurrency) {
                            return [2 /*return*/, userCurrency];
                        }
                        return [4 /*yield*/, Promise.all([
                                window.queryBus.query(IP_COUNTRY_QUERY),
                                window.queryBus.query(LANGUAGE_QUERY),
                            ])];
                    case 1:
                        _a = _b.sent(), country = _a[0], language = _a[1];
                        countryCurrency = country
                            ? countryToCurrency(country)
                            : Currency.EUR;
                        return [4 /*yield*/, configQuery('loggedOutCurrency')];
                    case 2:
                        loggedOutCurrency = _b.sent();
                        if (loggedOutCurrency && loggedOutCurrency.trim() !== '') {
                            return [2 /*return*/, loggedOutCurrency.toUpperCase()];
                        }
                        if (language) {
                            return [2 /*return*/, languageToCurrency(language, countryCurrency)];
                        }
                        return [2 /*return*/, countryCurrency];
                }
            });
        });
    };
    BalanceService.prototype.getUserCurrency = function () {
        if (this.isSweepstakes) {
            return this.sweepstakesCurrency;
        }
        return this.getUserProfileCurrency();
    };
    BalanceService.prototype.getUserProfileCurrency = function () {
        var user = magic.session.getUser();
        if (user) {
            return user.currency;
        }
    };
    BalanceService.prototype.registerBalanceEvents = function () {
        window.eventBus.register(BALANCE_UPDATED, {
            anyOf: [
                {
                    type: 'object',
                    properties: {
                        balance: {
                            type: 'number',
                            required: true,
                        },
                        bonusBalance: {
                            type: 'number',
                            required: true,
                        },
                        realBalance: {
                            type: 'number',
                            required: false,
                        },
                        bonusRealMoneyBalance: {
                            type: 'number',
                            required: false,
                        },
                        bonusBonusMoneyBalance: {
                            type: 'number',
                            required: false,
                        },
                        restricted: {
                            type: 'number',
                            required: false,
                        },
                        locked: {
                            type: 'number',
                            required: false,
                        },
                        withdrawable: {
                            type: 'number',
                            required: false,
                        },
                    },
                },
                {
                    type: 'null',
                },
            ],
        });
    };
    BalanceService.prototype.registerCurrencyEvents = function () {
        window.eventBus.register(BALANCE_CURRENCY_UPDATED, {
            anyOf: [
                {
                    type: 'string',
                },
                {
                    type: 'null',
                },
            ],
        });
    };
    return BalanceService;
}());

export { BalanceService };
